const { REACT_APP_API_URL = '', REACT_APP_INSIGHTS_URL = '' } = process.env

export const NAMESPACE = 'api.accounting'

export const ENDPOINTS = {
  FETCH_BANK_STATEMENT_JSON: `${REACT_APP_INSIGHTS_URL}/reports/transactional-bank-statement`,
  FETCH_BANK_STATEMENT_PDF: `${REACT_APP_INSIGHTS_URL}/reports/transactional-bank-statement/pdf`,
  FETCH_BANK_STATEMENT_CSV: `${REACT_APP_INSIGHTS_URL}/reports/transactional-bank-statement/csv`,
  FETCH_CUSTOMER_STATEMENTS: `${REACT_APP_API_URL}/accounting/customers`,
  FETCH_CUSTOMER_STATEMENT_PDF: `${REACT_APP_INSIGHTS_URL}/reports/customer-statement/:customerId/:accountId/pdf`,
  FETCH_CUSTOMER_STATEMENT_CSV: `${REACT_APP_INSIGHTS_URL}/reports/customer-statement/:customerId/:accountId/csv`,
  FETCH_CUSTOMER_STATEMENT_JSON: `${REACT_APP_INSIGHTS_URL}/reports/customer-statement/:customerId/:accountId`,
  FETCH_CONSOLIDATED_STATEMENT_JSON: `${REACT_APP_INSIGHTS_URL}/reports/consolidated-statement/:partyId`,
  FETCH_CONSOLIDATED_STATEMENT_PDF: `${REACT_APP_INSIGHTS_URL}/reports/consolidated-statement/:partyId/pdf`,
  FETCH_CONSOLIDATED_STATEMENT_CSV: `${REACT_APP_INSIGHTS_URL}/reports/consolidated-statement/:partyId/csv`,
  LEASE_STATEMENT_JSON: `${REACT_APP_INSIGHTS_URL}/reports/lease-statement/:portfolioId`,
  LEASE_STATEMENT_PDF: `${REACT_APP_INSIGHTS_URL}/reports/lease-statement/:portfolioId/pdf`,
  LEASE_STATEMENT_CSV: `${REACT_APP_INSIGHTS_URL}/reports/lease-statement/:portfolioId/csv`,
  // Per-lease, tenant-facing statement (CU-869dmfep1): on a lease's Tenant
  // wallet the Account Statement PDF/CSV downloads are replaced by these.
  TENANT_STATEMENT_PDF: `${REACT_APP_INSIGHTS_URL}/reports/tenant-statement/:portfolioId/pdf`,
  TENANT_STATEMENT_CSV: `${REACT_APP_INSIGHTS_URL}/reports/tenant-statement/:portfolioId/csv`,
  // le-go route: /reports/deposit-statement/:customerId/:accountId — the existing call sites supply the
  // customer/party id under the `id` payload key, so the path placeholder stays `:id` to match it.
  DEPOSIT_STATEMENT_JSON: `${REACT_APP_INSIGHTS_URL}/reports/deposit-statement/:id/:accountId`,
  DEPOSIT_STATEMENT_PDF: `${REACT_APP_INSIGHTS_URL}/reports/deposit-statement/:id/:accountId/pdf`,
  DEPOSIT_STATEMENT_CSV: `${REACT_APP_INSIGHTS_URL}/reports/deposit-statement/:id/:accountId/csv`,
  DEPOSIT_BANK_STATEMENT_JSON: `${REACT_APP_INSIGHTS_URL}/reports/deposit-bank-statement`,
  DEPOSIT_BANK_STATEMENT_PDF: `${REACT_APP_INSIGHTS_URL}/reports/deposit-bank-statement/pdf`,
  DEPOSIT_BANK_STATEMENT_CSV: `${REACT_APP_INSIGHTS_URL}/reports/deposit-bank-statement/csv`,
  COMMISSION_STATEMENT_JSON: `${REACT_APP_INSIGHTS_URL}/reports/commission-statement`,
  COMMISSION_STATEMENT_CSV: `${REACT_APP_INSIGHTS_URL}/reports/commission-statement/csv`,
  COMMISSION_STATEMENT_PDF: `${REACT_APP_INSIGHTS_URL}/reports/commission-statement/pdf`,
  GET_STATS_ACCOUNTING: `${REACT_APP_API_URL}/accounting/stats`,
  // reOS billing invoice counter, supportStaff. Served by le-go reporting-api.
  BILLING_AGENCY_SETTINGS: `${REACT_APP_INSIGHTS_URL}/reports/billing-agency-settings`,
  UPDATE_BILLING_INVOICE_NUMBER: `${REACT_APP_INSIGHTS_URL}/reports/billing-agency-settings/last-invoice-number`,
  BILLING_AGENCY_DISCOUNTS: `${REACT_APP_INSIGHTS_URL}/reports/billing-agency-settings/:agencyId`,
  // POST, not DELETE: the Kong CORS plugin on /insights allows only GET and POST.
  REMOVE_BILLING_AGENCY: `${REACT_APP_INSIGHTS_URL}/reports/billing-agency-settings/:agencyId/remove`,
}

// e.g. reOS5318
export const INVOICE_PREFIX = 'reOS'
